import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  private _cloudMaintenance;

  get cloudMaintenance() {
    return this._cloudMaintenance;
  }

  set cloudMaintenance(v) {
    this._cloudMaintenance = v;
  }

  constructor() { }
}
